/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FacilityResponse } from '../../models/facility-response';

export interface DeleteFacility$Params {
  facilityId: number;
}

export function deleteFacility(http: HttpClient, rootUrl: string, params: DeleteFacility$Params, context?: HttpContext): Observable<StrictHttpResponse<FacilityResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteFacility.PATH, 'delete');
  if (params) {
    rb.path('facilityId', params.facilityId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<FacilityResponse>;
    })
  );
}

deleteFacility.PATH = '/api/facility/{facilityId}';
